const $_iconsContainer = document.createElement('div');
$_iconsContainer.setAttribute('style', 'display: none;');
$_iconsContainer.innerHTML = `<svg>
    <defs>

    <!-- Actions -->

        <symbol id="zui-bookmark" viewBox="0 0 48 48">
            <title>zui-bookmark</title>
            <path d="M36,40l-12-8l-12,8V12c0-2.2,1.8-4,4-4h16c2.2,0,4,1.8,4,4V40z"/>
        </symbol>
        <symbol id="zui-calendar-add" viewBox="0 0 48 48">
            <title>zui-calendar-add</title>
            <path d="M38,8.5h-2v2.3c0,1.3-0.7,2.5-1.8,3.1c-1.8,1.2-4.3,0.7-5.5-1.1c-0.4-0.7-0.7-1.5-0.7-2.3v-2h-8v2.3c0,1.3-0.7,2.5-1.8,3.1
	c-1.8,1.2-4.3,0.7-5.5-1.1c-0.4-0.7-0.7-1.5-0.7-2.3v-2H9.3C7.5,8.5,6,10,6,11.8v27.4c0,1.8,1.5,3.3,3.3,3.3h29.4
	c1.8,0,3.3-1.5,3.3-3.3V12.5C42,10.3,40.2,8.5,38,8.5 M10,38.5v-20h28v20 M16,12.5c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2s2,0.9,2,2v4
	C18,11.6,17.1,12.5,16,12.5 M32,12.5c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2s2,0.9,2,2v4C34,11.6,33.1,12.5,32,12.5"/>
            <path d="M30,26.5v4h-4v4h-4v-4h-4v-4h4v-4h4v4H30z"/>
        </symbol>
        <symbol id="zui-check" viewBox="0 0 48 48">
            <title>zui-check</title>
            <path d="M40.9,12.2L17.8,35.3L15,38.1l-2.8-2.8l-7.1-7.1l2.8-2.8l7.1,7.1L38.1,9.4C38.1,9.4,40.9,12.2,40.9,12.2z"/>
        </symbol>
        <symbol id="zui-collapse" viewBox="0 0 48 48">
            <title>zui-collapse</title>
            <path d="M32.8,18H40v4H26V8h4v7.2l9.6-9.6l2.8,2.8L32.8,18z M15.2,30H8v-4h14v14h-4v-7.2l-9.6,9.6l-2.8-2.8L15.2,30z"/>
        </symbol>
        <symbol id="zui-clock" viewBox="0 0 48 48">
            <title>zui-clock</title>
            <path d="M24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20S35,4,24,4z M30.5,32L22,23.5V8h4v13.9l7.3,7.3L30.5,32z"/>
        </symbol>
        <symbol id="zui-close" viewBox="0 0 48 48">
            <title>zui-close</title>
            <path d="M39.6,36.7l-2.8,2.8L24,26.8L11.3,39.6l-2.8-2.8L21.2,24L8.4,11.3l2.8-2.8L24,21.2L36.7,8.4l2.8,2.8L26.8,24
	C26.8,24,39.6,36.7,39.6,36.7z"/>
        </symbol>
        <symbol id="zui-cloud-download" viewBox="0 0 48 48">
            <title>zui-cloud-download</title>
            <path d="M37.4,18.6c-2.1-7.4-9.9-11.7-17.3-9.6c-3.1,0.9-5.9,2.9-7.7,5.6c-6.6,0.9-11.1,7-10.2,13.6C3.1,34.1,8.1,38.4,14,38.5h22
	c5.5,0,10-4.6,9.9-10.1C45.9,23.5,42.3,19.4,37.4,18.6z M24,34.5l-8-10h4v-8h8v8h4L24,34.5z"/>
        </symbol>
        <symbol id="zui-cloud-upload" viewBox="0 0 48 48">
            <title>zui-cloud-upload</title>
            <path d="M37.4,18.6c-2.1-7.4-9.9-11.7-17.3-9.6c-3.1,0.9-5.9,2.9-7.7,5.6c-6.6,0.9-11.1,7-10.2,13.6C3.1,34.1,8.1,38.4,14,38.5h22
	c5.5,0,10-4.6,9.9-10.1C45.9,23.5,42.3,19.4,37.4,18.6z M24,16.5l8,10h-4v8h-8v-8h-4L24,16.5z"/>
        </symbol>
        <symbol id="zui-copy" viewBox="0 0 48 48">
            <title>zui-copy</title>
            <path d="M36,12v24c0,2.2-1.8,4-4,4H16c0,2.2,1.8,4,4,4h16c2.2,0,4-1.8,4-4V16C40,13.8,38.2,12,36,12z"/>
            <path d="M28,4H12C9.8,4,8,5.8,8,8v24c0,2.2,1.8,4,4,4h16c2.2,0,4-1.8,4-4V8C32,5.8,30.2,4,28,4z M28,22h-6v6h-4v-6h-6v-4h6v-6h4v6h6
	V22z"/>
        </symbol>
        <symbol id="zui-cut" viewBox="0 0 48 48">
            <title>zui-cut</title>
            <path d="M32.7,19.7c1.3,0.6,2.7,0.8,4.2,0.7c4.4-0.5,7.5-4.5,7-8.9S39.4,4,35,4.5c-3.7,0.4-6.6,3.4-7,7.1c-0.2,1.4,0.1,2.9,0.7,4.2
	L24,20.4l-4.7-4.7c0.6-1.3,0.9-2.7,0.7-4.2c-0.5-4.4-4.5-7.5-8.9-7c-4.4,0.5-7.5,4.5-7,8.9c0.4,3.7,3.3,6.6,7,7
	c1.4,0.2,2.9-0.1,4.2-0.7l4.7,4.7l-9.8,9.8c-1.5,2-2.2,4.5-2.2,7c-0.1,0.7,0.5,1.3,1.2,1.4c0.4,0,0.8-0.1,1-0.4L32.7,19.7z M32,12.4
	c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4S32,14.7,32,12.4 M8,12.4c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4S8,14.7,8,12.4 M37.8,34.2
	L30,26.4l-4,4l11.7,11.8c0.5,0.5,1.3,0.6,1.8,0.1c0.3-0.3,0.5-0.7,0.4-1.1C40,38.7,39.3,36.2,37.8,34.2"/>
        </symbol>
        <symbol id="zui-delete" viewBox="0 0 48 48">
            <title>zui-delete</title>
            <path d="M38,6.1v4H10v-4h9l1-2h8l0.9,2C28.9,6.1,38,6.1,38,6.1z M12,13.1h24v27c0,2.2-1.8,4-4,4H16c-2.2,0-4-1.8-4-4
	C12,40.1,12,13.1,12,13.1z"/>
        </symbol>
        <symbol id="zui-download" viewBox="0 0 48 48">
            <title>zui-download</title>
            <path d="M6,37.3h36v4H6V37.3z M34.3,23l-7.5,7.5L26,31.3l-2,2l-2-2l-0.8-0.8L13.7,23l2.8-2.8l5.5,5.5V8.1h4v17.5l5.5-5.5L34.3,23z" />
        </symbol>
        <symbol id="zui-external" viewBox="0 0 48 48">
            <title>zui-external</title>
            <path d="M37.5,6.5h-18c-2.2,0-4,1.8-4,4v18c0,2.2,1.8,4,4,4h18c2.2,0,4-1.8,4-4v-18C41.5,8.3,39.7,6.5,37.5,6.5z M35.5,25h-3.6v-6.5
	L23,27.4l-2.6-2.6l8.6-8.6h-6v-3.7h12.5V25L35.5,25z"/>
            <path d="M11.5,32.5v-18c-2.2,0-4,1.8-4,4v18c0,2.2,1.8,4,4,4h18c2.2,0,4-1.8,4-4h-18C13.3,36.5,11.5,34.7,11.5,32.5z"/>
        </symbol>
        <symbol id="zui-eye" viewBox="0 0 48 48">
            <title>zui-eye</title>
            <circle cx="24" cy="24" r="6"/>
            <path d="M24,10C12,10,4,24,4,24s8,14,20,14s20-14,20-14S36,10,24,10z M24,34c-5.5,0-10-4.5-10-10s4.5-10,10-10s10,4.5,10,10
	S29.5,34,24,34z"/>
        </symbol>
        <symbol id="zui-expand" viewBox="0 0 48 48">
            <title>zui-expand</title>
            <path d="M35.6,9.6h-7.2v-4h14v14h-4v-7.2L28.8,22L26,19.2L35.6,9.6z M12.4,38.4h7.2v4h-14v-14h4v7.2l9.6-9.6l2.8,2.8L12.4,38.4z"/>
        </symbol>
        <symbol id="zui-filter" viewBox="0 0 48 48">
            <title>zui-filter</title>
            <path d="M6,6h36L28,24v14l-8,4V24L6,6z"/>
        </symbol>
        <symbol id="zui-flag" viewBox="0 0 48 48">
            <title>zui-flag</title>
            <path d="M40,11v18c0,0.6-0.4,1-1,1H23c-1.7,0-3-1.3-3-3v-1h-6V6h10c1.7,0,3,1.3,3,3v16h3V10h9C39.6,10,40,10.4,40,11 M12,44V4H8v40
	H12z"/>
        </symbol>
        <symbol id="zui-folder-open" viewBox="0 0 48 48">
            <title>zui-folder-open</title>
            <path d="M3.5,22.6C4.2,19.4,7,17,10.4,17h32.7v-1c0-2.2-1.8-4-4-4h-16l-4-4H6.3c-1.8,0-3.2,1.4-3.2,3.2v13.5L3.5,22.6z"/>
            <path d="M39.8,40H5.5c-1.1,0-2-0.9-2-2c0-0.1,0-0.3,0-0.4l2.9-14.4c0.4-1.9,2.1-3.3,4-3.2h34.2c1.1,0,2,0.9,2,2c0,0.1,0,0.3,0,0.4
	l-2.9,14.4C43.4,38.7,41.7,40,39.8,40z"/>
        </symbol>
        <symbol id="zui-heart" viewBox="0 0 48 48">
            <title>zui-heart</title>
            <path d="M7.1,22.5c-0.6-1.1-0.9-2.3-1-3.5C6.2,20.2,6.5,21.4,7.1,22.5z M42,18.9c-0.1,1.2-0.4,2.4-1,3.5
	C41.5,21.4,41.8,20.2,42,18.9z"/>
            <path d="M42,18c0,0.3,0,0.6,0,0.9c-0.2,1.2-0.5,2.4-1,3.5C37.1,31.2,24,40,24,40S10.9,31.2,7.1,22.5c-0.5-1.1-0.8-2.3-1-3.5
	C6,18.6,6,18.3,6,18c0-5.5,4.5-10,10-10c3.1,0,6.1,1.5,8,4c3.3-4.4,9.6-5.3,14-2C40.5,11.9,42,14.9,42,18z"/>
        </symbol>
        <symbol id="zui-link" viewBox="0 0 48 48">
            <title>zui-link</title>
            <path d="M20.4,28.9c-0.3-0.2-0.5-0.4-0.7-0.6c-0.6-0.7-1.1-1.5-1.3-2.4c-0.3-1.6,0.2-3.2,1.3-4.4l0.8-0.8l5.8-5.8l2-2l1.4-1.4
	c1.9-1.9,4.9-1.8,6.7,0c1.8,1.8,1.8,4.7,0.1,6.6c0.7,1.5,1.1,3.1,1.1,4.8l1.8-1.8c3.5-3.5,3.5-9.2,0-12.7C35.9,5,30.2,5,26.7,8.5
	l0,0L23.3,12l-6.6,6.5c-2.1,2.2-3.1,5.2-2.4,8.2c0.3,1.7,1.2,3.3,2.4,4.5c0.2,0.2,0.5,0.4,0.7,0.6L20.4,28.9z"/>
            <path d="M27.2,19.5c0.3,0.2,0.5,0.3,0.7,0.6c1.8,1.9,1.8,4.9,0,6.7l-0.8,0.8l-5.8,5.8l-2,2L18,36.7c-1.8,1.9-4.8,1.9-6.7,0
	s-1.9-4.8,0-6.7c-0.8-1.5-1.1-3.1-1.1-4.8L8.3,27C5,30.6,5.2,36.3,8.8,39.7c3.5,3.2,8.8,3.2,12.3,0l3.3-3.3l6.6-6.6
	c2.1-2.1,3.1-5.2,2.4-8.2c-0.4-1.7-1.2-3.3-2.4-4.5c-0.2-0.2-0.5-0.4-0.7-0.6L27.2,19.5z"/>
        </symbol>
        <symbol id="zui-list" viewBox="0 0 48 48">
            <title>zui-list</title>
            <path d="M22,6h16c2.2,0,4,1.8,4,4v16c0,2.2-1.8,4-4,4H22c-2.2,0-4-1.8-4-4V10C18,7.8,19.8,6,22,6z"/>
            <path d="M19,33c-2.2,0-4-1.8-4-4V12.1c-1.8,0.5-3,2-3,3.9v16c0,2.2,1.8,4,4,4h16c1.8,0,3.4-1.2,3.9-3H19z"/>
            <path d="M13.1,38.9c-2.2,0-4-1.8-4-4V18c-1.8,0.4-3.1,2.1-3.1,4v16c0,2.2,1.8,4,4,4h16c1.9,0.1,3.6-1.2,4-3.1H13.1z"/>
        </symbol>
        <symbol id="zui-lock" viewBox="0 0 48 48">
            <style type="text/css">
	.st0{fill:none;}
	</style>
            <title>zui-lock</title>
            <path d="M36,20.9h-2v-7.3c0-0.2,0-0.4,0-0.7c-0.2-5.5-4.8-9.9-10.3-9.7S13.8,8.1,14,13.6v7.3h-2c-2.2,0-4,1.8-4,4v14
	c0,2.2,1.8,4,4,4h24c2.2,0,4-1.8,4-4v-14C40,22.7,38.2,20.9,36,20.9z M24,38.9c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6
	S27.3,38.9,24,38.9z M18,20.9v-7.3c0-3.3,2.7-6,6-6s6,2.7,6,6v7.3H18z"/>
            <circle class="st0" cx="24" cy="32.9" r="6"/>
            <path class="st0" d="M30,13.6v7.3H18v-7.3c0-3.3,2.7-6,6-6S30,10.3,30,13.6z"/>
        </symbol>
        <symbol id="zui-login" viewBox="0 0 48 48">
            <title>zui-login</title>
            <path d="M16.9,13.8l3.6,2.7V9h5c0.6-1,1.6-1.7,2.6-2.2L32.3,5H18.5c-1.1,0-2,0.9-2,2v6.5L16.9,13.8z M20.5,29.5l-3.6,2.7l-0.4,0.3
	V39c0,1.1,0.9,2,2,2h6v-4h-4V29.5z M42.5,5.2v35L31.3,45c-1,0.4-2.2,0-2.6-1.1c-0.1-0.2-0.1-0.5-0.2-0.7V12.5c0-0.8,0.5-1.5,1.2-1.8
	L42.5,5.2z M16.5,17v4h-12v4h12v4l8-6L16.5,17z"/>
        </symbol>
        <symbol id="zui-logout" viewBox="0 0 48 48">
            <title>zui-logout</title>
            <path d="M27.5,28.9v8h-4v4h6c1.1,0,2-0.9,2-2v-10H27.5z M29.5,4.9H15.7l4.2,1.8c1.1,0.5,2,1.2,2.6,2.2h5v8h4v-10
	C31.5,5.8,30.6,4.9,29.5,4.9z M18.3,10.7c0.7,0.3,1.2,1,1.2,1.8v30.7c0,1.1-0.9,2-2,2c-0.3,0-0.5-0.1-0.8-0.2L5.5,40.2v-35
	L18.3,10.7z M35.5,28.9v-4h-12v-4h12v-4l8,6L35.5,28.9z"/>
        </symbol>
        <symbol id="zui-minus" viewBox="0 0 48 48">
            <title>zui-minus</title>
            <path d="M4,22h40v4H4V22z"/>
        </symbol>
        <symbol id="zui-navigate" viewBox="0 0 48 48">
            <title>zui-navigate</title>
            <path d="M10,39.5L24,4.9l14,34.6c0.2,0.5,0,1.1-0.5,1.3c-0.3,0.1-0.6,0.1-0.8,0L24,32.9l-12.6,8c-0.4,0.3-1.1,0.2-1.4-0.2
	C9.8,40.4,9.8,39.9,10,39.5z"/>
        </symbol>
        <symbol id="zui-not-allowed" viewBox="0 0 48 48">
            <title>zui-not-allowed</title>
            <path d="M24,4.1c-11,0-20,9-20,20s9,20,20,20s20-9,20-20S35,4.1,24,4.1 M40,24.1c0,3.6-1.2,7.1-3.4,9.9L14.2,11.4
	c7-5.4,17-4.1,22.4,2.8C38.8,17.1,40,20.5,40,24.1 M8,24.1c0-3.5,1.2-7,3.4-9.8l22.4,22.4c-2.8,2.2-6.2,3.4-9.8,3.4
	C15.2,40.1,8,32.9,8,24.1"/>
        </symbol>
        <symbol id="zui-paper-plane" viewBox="0 0 48 48">
            <title>zui-paper-plane</title>
            <path d="M6.8,41.8l36.3-16.3c0.8-0.4,1.1-1.4,0.8-2.2c-0.2-0.3-0.4-0.6-0.8-0.8L6.8,6.2c-1-0.4-2.2,0-2.6,1C4,7.5,4,7.9,4,8.2V20
	l28.2,4L4,28v11.9C3.9,41,4.7,41.9,5.8,42C6.2,42,6.5,42,6.8,41.8"/>
        </symbol>
        <symbol id="zui-paperclip" viewBox="0 0 48 48">
            <title>zui-paperclip</title>
            <path d="M18.3,42.5c-2.8-0.1-5.4-1.2-7.2-3.3c-2.9-2.6-4-6.6-2.7-10.3c0.6-1.7,1.5-3.3,2.7-4.6l16-16c0.9-0.9,2-1.6,3.2-2
	c2.6-0.9,5.5-0.1,7.4,2c2.9,2.7,3.1,7.3,0.4,10.2c-0.1,0.1-0.3,0.3-0.4,0.4L22.8,33.9c-1.5,1.5-4.9,3.6-7.4,1.1s-0.4-6,1.1-7.4
	l16-16l2.1,2.1l-16,16c0,0-2,2.2-1.1,3.2s3.2-1,3.2-1.1l14.9-14.8c1.8-1.6,1.9-4.3,0.3-6.1c-0.1-0.1-0.2-0.2-0.3-0.3
	c-1.1-1.2-2.8-1.7-4.3-1.2c-0.7,0.3-1.4,0.7-2,1.2l-16,16c-2.9,2.7-3.1,7.2-0.4,10.2c0.1,0.1,0.3,0.3,0.4,0.4
	c2.7,2.9,7.3,3.1,10.2,0.4c0.1-0.1,0.3-0.3,0.4-0.4l14.8-14.8l2.1,2.1L26,39.3C23.9,41.3,21.2,42.5,18.3,42.5z"/>
        </symbol>
        <symbol id="zui-paste" viewBox="0 0 48 48">
            <title>zui-paste</title>
            <path d="M13.5,39h3v4h-5c-1.7,0-3-1.3-3-3l0,0V12c0-1.7,1.3-3,3-3h3.2c0.4-1.2,1.5-2,2.8-2c0.5-2.7,3.2-4.5,5.9-3.9
	c2,0.4,3.5,1.9,3.9,3.9h0.1c1.3,0,2.4,0.8,2.8,2h3.2c1.7,0,3,1.3,3,3v5h-3.9v-3.1c0-0.6-0.4-1-1-1h-1V14c0,0.6-0.4,1-1,1h-14
	c-0.6,0-1-0.4-1-1v-1h-1c-0.6,0-1,0.4-1,1v24C12.5,38.6,12.9,39,13.5,39 M20.5,8c0,1.1,0.9,2,2,2s2-0.9,2-2c0-1.1-0.9-2-2-2
	S20.5,6.9,20.5,8"/>
            <path d="M38.5,37.5L33,43v-5.5H38.5z"/>
            <path d="M38.5,35.3v-12c0.1-1.2-0.9-2.2-2.1-2.3c0,0-0.1,0-0.1,0H23.1c-1.2,0-2.2,1-2.2,2.2l0,0v17.6c0,1.2,1,2.2,2.2,2.2h7.7v-7.7
	H38.5z"/>
        </symbol>
        <symbol id="zui-pencil" viewBox="0 0 48 48">
            <title>zui-pencil</title>
            <path d="M15.7,38.5H9.5v-6.2l20.2-20.2l6.2,6.2L15.7,38.5z"/>
            <path d="M36,9.1l2.8,2.8c0.9,0.9,0.9,2.5,0,3.4l0,0l-1.4,1.4l-6.2-6.2l1.4-1.4C33.6,8.2,35.1,8.2,36,9.1C36,9.1,36,9.1,36,9.1z"/>
        </symbol>
        <symbol id="zui-pin" viewBox="0 0 48 48">
            <title>zui-pin</title>
            <path d="M34,24l-3.6-12.6c1.7-0.5,2.9-2,2.9-3.8V7c0-0.6-0.4-1-1-1H15.7c-0.6,0-1,0.4-1,1v0.6c0,1.8,1.2,3.3,2.9,3.8L14,24
	c-2.5,0.2-4.2,2.4-4,4.9c0,0,0,0.1,0,0.1c0,0.6,0.4,1,1,1h9c0.1,1.4,0.4,2.7,1,4l2.1,7.5c0.2,0.5,0.8,0.7,1.3,0.5
	c0.2-0.1,0.4-0.3,0.5-0.5L27,34c0.6-1.3,0.9-2.6,1-4h9c0.6,0,1-0.4,1-1c0.3-2.4-1.4-4.7-3.9-5C34.1,24,34,24,34,24z M20.2,24H16
	l3.6-12h4.2L20.2,24z"/>
        </symbol>
        <symbol id="zui-play" viewBox="0 0 48 48">
            <title>zui-play</title>
            <path d="M40,8H8c-2.2,0-4,1.8-4,4v24c0,2.2,1.8,4,4,4h32c2.2,0,4-1.8,4-4V12C44,9.8,42.2,8,40,8z M20,32V16l10.7,8L20,32z"/>
        </symbol>
        <symbol id="zui-play-circle" viewBox="0 0 48 48">
            <title>zui-play-circle</title>
            <path d="M24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20S35,4,24,4z M20,32V16l10.7,8L20,32z"/>
        </symbol>
        <symbol id="zui-plus" viewBox="0 0 48 48">
            <title>zui-plus</title>
            <path d="M44,22v4H26v18h-4V26H4v-4h18V4h4v18H44z"/>
        </symbol>
        <symbol id="zui-power" viewBox="0 0 48 48">
            <title>zui-power</title>
            <path d="M22,4.5h4v18h-4V4.5z"/>
            <path d="M30,7.6v4.3c7,3.3,10,11.7,6.6,18.6c-3.3,7-11.7,10-18.6,6.6S8,25.5,11.4,18.5c1.4-2.9,3.7-5.3,6.6-6.6V7.6
	c-9.4,3.3-14.3,13.6-11,23s13.6,14.3,23,11c9.4-3.3,14.3-13.6,11-23C39.2,13.4,35.1,9.4,30,7.6z"/>
        </symbol>
        <symbol id="zui-print" viewBox="0 0 48 48">
            <title>zui-print</title>
            <path d="M12,4h24v6H12V4z M40,14H8c-2.2,0-4,1.8-4,4v12c0,2.2,1.8,4,4,4h4v10h24V34h4c2.2,0,4-1.8,4-4V18C44,15.8,42.2,14,40,14z
	 M10,22c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S11.1,22,10,22z M32,40H16V28h16V40z"/>
        </symbol>
        <symbol id="zui-reload" viewBox="0 0 48 48">
            <title>zui-reload</title>
            <path d="M32,20l3.7-3.7l-0.1-0.1c-0.2-0.3-0.3-0.5-0.6-0.8c-0.6-0.7-1.3-1.4-2-2c-0.2-0.2-0.4-0.4-0.6-0.5c-0.9-0.7-1.9-1.3-3-1.8
	c-0.3-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.6-0.2-0.8-0.3l-0.9-0.2c-0.5-0.1-1-0.2-1.6-0.3h-1.3c-0.5,0-1,0-1.4,0c-0.4,0-0.8,0.1-1.2,0.2
	c-0.4,0.1-0.9,0.2-1.3,0.3c-0.4,0.1-0.7,0.2-1,0.4c-0.5,0.2-1,0.4-1.5,0.7c-0.3,0.2-0.7,0.4-1,0.6c-1.7,1.1-3.2,2.6-4.3,4.3
	c-0.2,0.3-0.4,0.7-0.6,1c-0.3,0.5-0.5,1-0.7,1.5c-0.1,0.3-0.3,0.7-0.4,1c-0.1,0.4-0.2,0.9-0.3,1.3c-0.1,0.4-0.1,0.8-0.2,1.2
	c0,0.5,0,1,0,1.4c0,7.7,6.3,14,14,14s14-6.3,14-14h4c0,9.9-8.1,18-18,18S6,33.9,6,24c0-1.4,0.2-2.9,0.5-4.3c0-0.2,0.1-0.4,0.2-0.7
	c0.1-0.4,0.2-0.9,0.4-1.3c0-0.3,0.2-0.5,0.3-0.8c0.1-0.3,0.3-0.6,0.4-0.9c0.1-0.2,0.2-0.4,0.3-0.7l0.5-0.8c0.1-0.2,0.3-0.5,0.4-0.7
	c1.3-1.9,3-3.6,4.9-4.9l0.7-0.4c1.4-0.9,2.9-1.5,4.4-2l0.7-0.2C21.2,6.1,22.6,6,24,6h1.7c0.5,0,0.9,0.1,1.4,0.2l1.1,0.2l0.6,0.1
	c0.4,0.1,0.7,0.2,1,0.3l0.5,0.2c0.4,0.1,0.7,0.3,1.1,0.5c0.4,0.2,0.8,0.4,1.2,0.6C33.2,8.5,33.6,8.7,34,9c0.4,0.3,0.8,0.6,1.2,0.9
	c0.8,0.6,1.5,1.3,2.2,2c0.2,0.2,0.4,0.5,0.6,0.7c0.2,0.2,0.3,0.4,0.5,0.6L42,10v10H32z"/>
        </symbol>
        <symbol id="zui-save" viewBox="0 0 48 48">
            <title>zui-save</title>
            <path d="M34,6H10c-2.2,0-4,1.8-4,4v28c0,2.2,1.8,4,4,4h28c2.2,0,4-1.8,4-4V14L34,6z M24,38c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6
	S27.3,38,24,38z M30,18H10v-8h20V18z"/>
        </symbol>
        <symbol id="zui-search" viewBox="0 0 48 48">
            <title>zui-search</title>
            <path d="M19.6,12.6c5,0,9,4,9,9c0,1.9-0.6,3.8-1.7,5.3l-0.8,1.2l-1.2,0.8c-1.5,1.1-3.4,1.7-5.3,1.7c-5,0-9-4-9-9
	S14.7,12.6,19.6,12.6 M19.6,8.6c-7.2,0-13,5.8-13,13s5.8,13,13,13c2.8,0,5.4-0.9,7.7-2.5l10,10l2.8-2.8l-10-10
	c1.6-2.2,2.5-4.9,2.5-7.7C32.6,14.4,26.8,8.6,19.6,8.6z"/>
        </symbol>
        <symbol id="zui-sort" viewBox="0 0 48 48">
            <title>zui-sort</title>
            <path d="M17.3,20.4l-2.9-2.9L23.9,8l9.5,9.5l-2.9,2.9l-6.6-6.6C23.9,13.8,17.3,20.4,17.3,20.4z M30.5,27.6l2.9,2.9L23.9,40l-9.5-9.5
	l2.9-2.9l6.6,6.6L30.5,27.6z"/>
        </symbol>
        <symbol id="zui-sort-az" viewBox="0 0 48 48">
            <title>zui-sort-az</title>
            <path d="M22,35.5l-2.3-6.3h-8.8l-2.2,6.3h-4l8.5-22.9h4L26,35.5H22z M18.7,26l-2.1-6.2c-0.2-0.4-0.4-1.1-0.7-2s-0.5-1.6-0.6-2
	C15,17.2,14.5,18.6,14,20l-2,6H18.7z M31.4,32.4l11.6-17v-2.7H27.3v3.2h11.2L26.9,32.9v2.6h16.3v-3.2L31.4,32.4z M24,44l4-4h-8
	L24,44z"/>
            <path d="M24,4l-4,4h8L24,4z"/>
        </symbol>
        <symbol id="zui-star" viewBox="0 0 48 48">
            <title>zui-star</title>
            <path d="M33.8,41.8l-9.2-7c-0.4-0.3-0.9-0.3-1.2,0l-9.1,7.1c-0.4,0.3-1.1,0.3-1.4-0.2c-0.2-0.3-0.3-0.6-0.2-0.9l3.5-11.6
	c0.1-0.4,0-0.9-0.4-1.1l-9.4-7.2c-0.5-0.4-0.5-1-0.2-1.5c0.2-0.2,0.5-0.4,0.8-0.4h11.4c0.5,0,0.9-0.4,1-0.9l3.4-11.5
	C23,6,23.5,5.7,24.1,5.8c0.4,0.1,0.7,0.4,0.8,0.8l3.5,11.5c0.1,0.4,0.5,0.7,1,0.7h11.4c0.6,0,1,0.5,1,1c0,0.3-0.1,0.6-0.4,0.8
	l-9.4,7.2c-0.3,0.3-0.5,0.7-0.4,1.1l3.6,11.6c0.1,0.5-0.2,1.1-0.7,1.2C34.3,41.9,34,41.9,33.8,41.8z"/>
        </symbol>
        <symbol id="zui-stop" viewBox="0 0 48 48">
            <title>zui-stop</title>
            <path d="M24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20S35,4,24,4z M30,30H18V18h12V30z"/>
        </symbol>
        <symbol id="zui-sync" viewBox="0 0 48 48">
            <title>zui-sync</title>
            <path d="M6,38V28h10l-3.7,3.7c0.5,0.8,1.1,1.5,1.8,2.2c5.5,5.5,14.3,5.5,19.8,0c2.6-2.6,4.1-6.2,4.1-9.9h4c0,9.9-8.1,18-18,18
	c-4.8,0-9.3-1.9-12.7-5.3c-0.7-0.7-1.3-1.4-1.8-2.2L6,38z M42,10v10H32l3.7-3.7c-0.5-0.8-1.1-1.5-1.8-2.2c-5.5-5.5-14.3-5.5-19.8,0
	C11.5,16.7,10,20.3,10,24H6c0-9.9,8.1-18,18-18c4.8,0,9.3,1.9,12.7,5.3c0.7,0.7,1.3,1.4,1.8,2.2L42,10z"/>
        </symbol>
        <symbol id="zui-tag" viewBox="0 0 48 48">
            <title>zui-tag</title>
            <path d="M42.5,23.9V8.5c0-1.6-1.3-3-2.9-3c0,0-0.1,0-0.1,0H24.1c-0.8,0-1.5,0.3-2,0.9L5.4,23c-1.2,1.1-1.2,3,0,4.2c0,0,0,0,0,0
	l15.4,15.4c1.1,1.2,3,1.2,4.2,0c0,0,0,0,0,0L41.7,26c0.5-0.5,0.8-1.2,0.9-2 M37.3,10.3c1.2,1,1.4,2.8,0.4,4s-2.8,1.4-4,0.4
	c-0.1-0.1-0.3-0.2-0.4-0.4c-1-1.2-0.8-3,0.4-4C34.7,9.4,36.3,9.4,37.3,10.3 M25.2,35.5L12.5,22.8l2.8-2.8L28,32.7L25.2,35.5z"/>
        </symbol>
        <symbol id="zui-unlink" viewBox="0 0 48 48">
            <title>zui-unlink</title>
            <path d="M36,14H26v4h10c3.3,0,6,2.7,6,6s-2.7,6-6,6H26v4h10c5.5,0,10-4.5,10-10S41.5,14,36,14z M22,30H12c-3.3,0-6-2.7-6-6
	s2.7-6,6-6h10v-4H12C6.5,14,2,18.5,2,24s4.5,10,10,10h10V30z"/>
            <path d="M14,22h20v4H14V22z"/>
        </symbol>
        <symbol id="zui-unlock" viewBox="0 0 48 48">
            <title>zui-unlock</title>
            <path d="M36,20.8H18v-7.3c0-3.3,2.7-6,6-6s6,2.7,6,6c0,1.1,0.9,2,2,2s2-0.9,2-2c0-5.5-4.5-10-10-10S14,8,14,13.5v7.3h-2
	c-2.2,0-4,1.8-4,4v14c0,2.2,1.8,4,4,4h24c2.2,0,4-1.8,4-4v-14C40,22.6,38.2,20.8,36,20.8z M24,38.8c-3.3,0-6-2.7-6-6s2.7-6,6-6
	s6,2.7,6,6S27.3,38.8,24,38.8z"/>
        </symbol>
        <symbol id="zui-upload" viewBox="0 0 48 48">
            <title>zui-upload</title>
            <path d="M6,6.7h36v4H6V6.7z"/>
            <path d="M13.7,25l7.5-7.5l0.8-0.8l2-2l2,2l0.8,0.8l7.5,7.5l-2.8,2.8L26,22.4v17.5h-4V22.4l-5.5,5.5L13.7,25z"/>
        </symbol>
        <symbol id="zui-user" viewBox="0 0 48 48">
            <title>zui-user</title>
            <circle cx="24" cy="16" r="8"/>
            <path d="M40,40v-7.5c-9.8-6.1-22.2-6.1-32,0V40H40z"/>
        </symbol>
        <symbol id="zui-user-add" viewBox="0 0 48 48">
            <title>zui-user-add</title>
            <circle cx="28" cy="16" r="8"/>
            <path d="M44,40v-7.5c-9.8-6.1-22.2-6.1-32,0V40H44z"/>
            <path d="M8,16h4v12H8V16z"/>
            <path d="M4,20h12v4H4V20z"/>
        </symbol>
        <symbol id="zui-wrench" viewBox="0 0 48 48">
            <title>zui-wrench</title>
            <path d="M40.5,13.2L35.6,18l-4.2-1.5L30,12.3l4.9-4.9c-4.3-1.1-8.6,1.4-9.8,5.7c-0.4,1.3-0.4,2.8,0,4.1L9.3,32.9
	c-1.6,1.6-1.6,4.1,0,5.7s4.1,1.6,5.7,0l15.7-15.7c4.3,1.1,8.6-1.4,9.8-5.7C40.9,15.8,40.9,14.4,40.5,13.2L40.5,13.2z M10.8,37.3
	c-0.8-0.8-0.8-2.1,0-2.8s2.1-0.8,2.8,0c0.8,0.8,0.8,2,0,2.8C12.8,38,11.6,38,10.8,37.3C10.8,37.3,10.8,37.3,10.8,37.3z"/>
        </symbol>


    
    <!-- Alerts -->
    
        <symbol id="zui-alert-circle" viewBox="0 0 48 48">
            <title>zui-alert-circle</title>
            <path d="M24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20S35,4,24,4z M22,12h4v16h-4V12z M24,36c-1.4,0-2.5-1.1-2.5-2.5S22.6,31,24,31
	s2.5,1.1,2.5,2.5S25.4,36,24,36z"/>
        </symbol>
        <symbol id="zui-alert" viewBox="0 0 48 48">
            <title>zui-alert</title>
            <path d="M46.8,39.3c-0.1-0.4-0.2-0.8-0.4-1.1l-7.7-13.3L27.6,5.5C27.2,4.9,26.7,4.3,26,4c-0.6-0.3-1.3-0.5-2-0.5
	c-1.4,0-2.7,0.8-3.5,2L1.7,38.2c-1.1,1.9-0.4,4.4,1.5,5.5c0.6,0.4,1.3,0.5,2,0.5h37.7c2.2,0,4-1.8,4-4
	C46.9,39.9,46.9,39.6,46.8,39.3 M26,30.2h-4v-16h4V30.2z M24,39.1c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5
	C26.5,38,25.4,39.1,24,39.1z"/>
        </symbol>
        <symbol id="zui-bell" viewBox="0 0 48 48">
            <title>zui-bell</title>
            <path d="M24,45.5c2.2,0,4-1.8,4-4h-8C20,43.7,21.8,45.5,24,45.5z M42,36.5c0,0.3,0,0.7,0,1H6.1C6,37.2,6,36.8,6,36.5
	c0-2.4,1.7-4.4,4-4.9V21.5c0-6.6,4.6-12.3,11-13.7V6.5c0-1.7,1.3-3,3-3s3,1.3,3,3v1.3c6.4,1.4,11,7.1,11,13.7v10.1
	C40.3,32.1,42,34.1,42,36.5z"/>
        </symbol>
        <symbol id="zui-bell-ringing" viewBox="0 0 48 48">
            <title>zui-bell-ringing</title>
            <path d="M24,45.5c2.2,0,4-1.8,4-4h-8C20,43.7,21.8,45.5,24,45.5z M42,36.5c0,0.3,0,0.7,0,1H6.1C6,37.2,6,36.8,6,36.5
	c0-2.4,1.7-4.4,4-4.9V21.5c0-6.6,4.6-12.3,11-13.7V6.5c0-1.7,1.3-3,3-3s3,1.3,3,3v1.3c6.4,1.4,11,7.1,11,13.7v10.1
	C40.3,32.1,42,34.1,42,36.5z"/>
            <path d="M42.5,23.5h3c0-8-4.4-15.3-11.5-19V8C39.3,11.4,42.5,17.2,42.5,23.5z M14,8V4.5c-7.1,3.7-11.5,11-11.5,19h3
	C5.5,17.2,8.7,11.4,14,8z"/>
        </symbol>
        <symbol id="zui-check-circle" viewBox="0 0 48 48">
            <title>zui-check-circle</title>
            <path d="M24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20S35,4,24,4z M32.7,20L22.5,30.2l-1.3,1.2l-0.7,0.7l-0.7-0.7l-1.2-1.2l-3.1-3.1
	l-0.7-0.7l0.7-0.7l1.3-1.3l0.7-0.7l0.7,0.7l2.4,2.4l9.5-9.5l0.7-0.7l0.7,0.7l1.3,1.3l0.7,0.7L32.7,20z"/>
        </symbol>
        <symbol id="zui-close-circle" viewBox="0 0 48 48">
            <title>zui-close-circle</title>
            <path d="M38.1,9.9C30.3,2,17.7,2,9.9,9.9S2,30.3,9.9,38.1s20.5,7.8,28.3,0c0,0,0,0,0,0C45.9,30.3,45.9,17.7,38.1,9.9z M32.5,31.1
	l-1.4,1.4l-0.7,0.7l-0.7-0.7L24,26.8l-5.7,5.7l-0.7,0.7l-0.7-0.7l-1.4-1.4l-0.7-0.7l0.7-0.7l5.7-5.7l-5.7-5.7l-0.7-0.7l0.7-0.7
	l1.4-1.4l0.7-0.7l0.7,0.7l5.7,5.7l5.7-5.7l0.7-0.7l0.7,0.7l1.4,1.4l0.7,0.7l-0.7,0.7L26.8,24l5.7,5.7l0.7,0.7L32.5,31.1z"/>
        </symbol>
        <symbol id="zui-help" viewBox="0 0 48 48">
            <title>zui-help</title>
            <path d="M24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20S35,4,24,4z M29.4,23.4c-0.7,0.7-1.4,1.4-2.2,2c-1.3,1-1.3,1-1.3,2.6h-4
	c-0.3-2.3,0.8-4.5,2.7-5.7c0.5-0.4,1.1-0.9,1.9-1.7c1-1.3,1.3-3,0.6-4.5c-0.5-1.3-1.8-2.2-3.2-2.1c-3.7,0-4,3.9-4,4.3l-4-0.2
	c0-4.4,3.6-8,8-8.1c3-0.1,5.8,1.8,6.9,4.6C32.2,17.6,31.6,21,29.4,23.4z M24,37c-1.4,0-2.5-1.1-2.5-2.5S22.6,32,24,32
	s2.5,1.1,2.5,2.5S25.4,37,24,37z"/>
        </symbol>
        <symbol id="zui-info" viewBox="0 0 48 48">
            <title>zui-info</title>
            <path d="M24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20S35,4,24,4z M26,36h-4V20h4V36z M24,16.5c-1.4,0-2.5-1.1-2.5-2.5
	c0-1.4,1.1-2.5,2.5-2.5c1.4,0,2.5,1.1,2.5,2.5C26.5,15.4,25.4,16.5,24,16.5C24,16.5,24,16.5,24,16.5z"/>
        </symbol>
        <symbol id="zui-minus-circle" viewBox="0 0 48 48">
            <title>zui-minus-circle</title>
            <path d="M24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20S35,4,24,4z M36,26H12v-4h24V26z"/>
        </symbol>
        <symbol id="zui-plus-circle" viewBox="0 0 48 48">
            <title>zui-plus-circle</title>
            <path d="M24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20S35,4,24,4z M35,23v3h-9v9h-4v-9h-9v-4h9v-9h4v9h9V23z"/>
        </symbol>



    <!-- Directional -->
   
        <symbol id="zui-arrow-down" viewBox="0 0 48 48">
            <title>zui-arrow-down</title>
            <path d="M24,44L8,28.3l2.8-2.8l11.2,11V4h4v32.5l11.2-11l2.8,2.8L26.8,41.2L24,44z"/>
        </symbol>
        <symbol id="zui-arrow-down-circle" viewBox="0 0 48 48">
            <title>zui-arrow-down-circle</title>
            <path d="M46,24c0-12.2-9.8-22-22-22S2,11.8,2,24s9.8,22,22,22S46,36.2,46,24z M14,23.8h5.4V12h9.2v11.8H34L24,38L14,23.8z"/>
        </symbol>
        <symbol id="zui-arrow-left" viewBox="0 0 48 48">
            <title>zui-arrow-left</title>
            <path d="M4,24L19.7,8l2.8,2.8L11.5,22H44v4H11.5l11,11.2L19.7,40L6.8,26.8L4,24z"/>
        </symbol>
        <symbol id="zui-arrow-left-circle" viewBox="0 0 48 48">
            <title>zui-arrow-left-circle</title>
            <path d="M24,46c12.2,0,22-9.8,22-22S36.2,2,24,2S2,11.8,2,24S11.8,46,24,46z M24.2,14v5.4H36v9.2H24.2V34L10,24L24.2,14z"/> 
        </symbol>
        <symbol id="zui-arrow-right" viewBox="0 0 48 48">
            <title>zui-arrow-right</title>
            <path d="M44,24L28.3,40l-2.8-2.8l11-11.2H4v-4h32.5l-11-11.2L28.3,8l12.9,13.2L44,24z"/>
        </symbol>
        <symbol id="zui-arrow-right-circle" viewBox="0 0 48 48">
            <title>zui-arrow-right-circle</title>
            <path d="M24,2C11.8,2,2,11.8,2,24s9.8,22,22,22s22-9.8,22-22S36.2,2,24,2z M23.8,34v-5.4H12v-9.2h11.8V14L38,24L23.8,34z"/>
        </symbol>
        <symbol id="zui-arrow-up" viewBox="0 0 48 48">
            <title>zui-arrow-up</title>
            <path d="M24,4l16,15.7l-2.8,2.8L26,11.5V44h-4V11.5l-11.2,11L8,19.7L21.2,6.8L24,4z"/>
        </symbol>
        <symbol id="zui-arrow-up-circle" viewBox="0 0 48 48">
            <title>zui-arrow-up-circle</title>
            <path d="M2,24c0,12.2,9.8,22,22,22s22-9.8,22-22S36.2,2,24,2S2,11.8,2,24z M34,24.2h-5.4V36h-9.2V24.2H14L24,10L34,24.2z"/> 
        </symbol>
        <symbol id="zui-caret-down" viewBox="0 0 48 48">
            <title>zui-caret-down</title>
            <path d="M32,18.5H16l8,10L32,18.5z"/>
        </symbol>
        <symbol id="zui-caret-left" viewBox="0 0 48 48">
            <title>zui-caret-left</title>
            <path d="M27.5,32V16l-10,8L27.5,32z"/>
        </symbol>
        <symbol id="zui-caret-right" viewBox="0 0 48 48">
            <title>zui-caret-right</title>
            <path d="M19.5,16v16l10-8L19.5,16z"/>
        </symbol>
        <symbol id="zui-caret-up" viewBox="0 0 48 48">
            <title>zui-caret-up</title>
            <path d="M16,27.5h16l-8-10L16,27.5z"/>
        </symbol>
        <symbol id="zui-chevron-down" viewBox="0 0 48 48">
            <title>zui-chevron-down</title>
            <path d="M30.6,17.9l2.9,2.9L24,30.3l-9.5-9.5l2.9-2.9l6.6,6.6L30.6,17.9z"/>
        </symbol>
        <symbol id="zui-chevron-left" viewBox="0 0 48 48">
            <title>zui-chevron-left</title>
            <path d="M30.1,30.6l-2.9,2.9L17.7,24l9.5-9.5l2.9,2.9L23.5,24L30.1,30.6z"/>
        </symbol>
        <symbol id="zui-chevron-right" viewBox="0 0 48 48">
            <title>zui-chevron-right</title>
            <path d="M17.9,17.4l2.9-2.9l9.5,9.5l-9.5,9.5l-2.9-2.9l6.6-6.6L17.9,17.4z"/>
        </symbol>
        <symbol id="zui-chevron-up" viewBox="0 0 48 48">
            <title>zui-chevron-up</title>
            <path d="M17.4,30.1l-2.9-2.9l9.5-9.5l9.5,9.5l-2.9,2.9L24,23.5L17.4,30.1z"/>
        </symbol>
        <symbol id="zui-double-chevron-left" viewBox="0 0 48 48">
            <title>zui-double-chevron-left</title>
            <path d="M24.4,30.3l-2.9,2.9L12,23.8l9.5-9.5l2.9,2.9l-6.6,6.6L24.4,30.3z"/>
            <path d="M35.9,30.3L33,33.3l-9.5-9.5l9.5-9.5l2.9,2.9l-6.6,6.6L35.9,30.3z"/>
        </symbol>
        <symbol id="zui-double-chevron-right" viewBox="0 0 48 48">
            <title>zui-double-chevron-right</title>
            <path d="M23.6,17.7l2.9-2.9l9.5,9.5l-9.5,9.5l-2.9-2.9l6.6-6.6L23.6,17.7z"/>
            <path d="M12.1,17.7l2.9-2.9l9.5,9.5L15,33.8l-2.9-2.9l6.6-6.6L12.1,17.7z"/>
        </symbol>
        <symbol id="zui-down" viewBox="0 0 48 48">
            <title>zui-down</title>
            <path d="M37.1,15.3l2.9,2.9l-16,16l-16-16l2.9-2.9L24,28.4L37.1,15.3z"/>
        </symbol>
        <symbol id="zui-left" viewBox="0 0 48 48">
            <title>zui-left</title>
            <path d="M32.7,37.1L29.8,40l-16-16l16-16l2.9,2.9L19.6,24L32.7,37.1z"/>
        </symbol>
        <symbol id="zui-right" viewBox="0 0 48 48">
            <title>zui-right</title>
            <path d="M15.3,10.9L18.2,8l16,16l-16,16l-2.9-2.9L28.4,24L15.3,10.9z"/>
        </symbol>
        <symbol id="zui-up" viewBox="0 0 48 48">
            <title>zui-up</title>
            <path d="M10.9,32.7L8,29.8l16-16l16,16l-2.9,2.9L24,19.6L10.9,32.7z"/>
        </symbol>
        



    <!-- File -->

        <symbol id="zui-file-documents" viewBox="0 0 48 48">
            <title>zui-file-documents</title>
            <path d="M36,12v24c0,2.2-1.8,4-4,4H16c0,2.2,1.8,4,4,4h16c2.2,0,4-1.8,4-4V16C40,13.8,38.2,12,36,12z"/>
            <path d="M28,4H12C9.8,4,8,5.8,8,8v24c0,2.2,1.8,4,4,4h16c2.2,0,4-1.8,4-4V8C32,5.8,30.2,4,28,4z M28,13H12v-3h16V13z M28,19H12v-3
	h16V19z M22,25H12v-3h10V25z"/>
        </symbol>
        <symbol id="zui-file-excel" viewBox="0 0 48 48">
            <title>zui-file-excel</title>
            <path d="M40,13.9l-10-10v10H40z"/>
            <path d="M26,17.9v-14H12c-2.2,0-4,1.8-4,4v32c0,2.2,1.8,4,4,4h24c2.2,0,4-1.8,4-4v-22L26,17.9z M27.8,37.5l-3-5.4l-3,5.5H18l4.7-7.9
	l-4.6-7.7h3.7l2.9,5.4l2.9-5.4h3.7l-4.6,7.7l4.7,7.9L27.8,37.5z"/>
        </symbol>
        <symbol id="zui-file-pdf" viewBox="0 0 48 48">
            <title>zui-file-pdf</title>
            <path d="M40,13.9l-10-10v10H40z M23.8,30l-0.5,0.9l0,0l-0.6,1h2.2l-0.6-1C24.3,30.9,23.8,30,23.8,30z M17,34.9
	c-0.3-0.3-0.7-0.5-1.1-0.5c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5c0.2,0,0.3,0,0.5,0c0.6-0.2,1-0.8,1-1.4c0-0.2,0-0.4-0.1-0.6
	C17.2,35.2,17.1,35,17,34.9z M23.8,22.3c-0.7,0-1.3,0.5-1.4,1.1c0,0.1,0,0.3,0,0.4c0,0.7,0.5,1.3,1.1,1.4c0.1,0,0.2,0,0.4,0
	c0.1,0,0.2,0,0.3,0c0.7-0.1,1.2-0.7,1.2-1.5c0-0.2,0-0.4-0.1-0.5C25.1,22.7,24.5,22.3,23.8,22.3z M32.1,34.4h-0.2
	c-0.7,0-1.3,0.5-1.4,1.1c0,0.1,0,0.3,0,0.4c0,0.3,0.1,0.5,0.2,0.8c0.3,0.4,0.8,0.7,1.3,0.7c0.8,0,1.5-0.7,1.5-1.5
	C33.4,35.2,32.9,34.5,32.1,34.4L32.1,34.4z"/>
            <path d="M26,17.9v-14H12c-2.2,0-4,1.8-4,4v32c0,2.2,1.8,4,4,4h24c2.2,0,4-1.8,4-4v-22L26,17.9z M31.8,39.9c-1.4,0-2.7-0.8-3.5-2
	v-0.1l-1.7-2.9h-5.8c-0.6,1.3-1.3,2.6-2.2,3.8c-0.8,0.8-1.8,1.2-2.9,1.2c-2.2,0-4-1.8-4-4s1.8-4,4-4h3.4l2.3-4l-1-1.7v-0.1l-0.3-0.5
	c-0.3-0.5-0.4-1.1-0.4-1.7c0-2.2,1.8-4,4-4c1.5,0,2.9,0.8,3.5,2.2c0.3,0.6,0.4,1.2,0.4,1.8c0,0.6-0.1,1.2-0.4,1.7l-0.3,0.5l-1,1.7
	l2.3,4h3.7c2.1,0.1,3.7,1.9,3.7,4c0.1,2.2-1.7,4-3.9,4.1C32,39.9,31.9,39.9,31.8,39.9z"/>
        </symbol>
        <symbol id="zui-file-powerpoint" viewBox="0 0 48 48">
            <title>zui-file-powerpoint</title>
            <path d="M40,13.9l-10-10v10H40z"/>
            <path d="M26,17.9v-14H12c-2.2,0-4,1.8-4,4v32c0,2.2,1.8,4,4,4h24c2.2,0,4-1.8,4-4v-22L26,17.9z M28.4,31.1c-1.2,0.9-2.8,1.4-4.4,1.3
	h-2.8v5.5H18V22.3h6c1.1,0,2.1,0.2,3.1,0.6c0.8,0.4,1.5,1,2,1.8c0.6,0.8,0.9,1.7,0.9,2.7C30.1,28.8,29.5,30.2,28.4,31.1z"/>
            <path d="M26,25.9c0.5,0.5,0.7,1.2,0.7,1.8c0,0.6-0.2,1.3-0.7,1.7c-0.6,0.4-1.3,0.7-2,0.6h-2.7v-4.9h2.9C24.9,25.1,25.6,25.4,26,25.9
	"/>
        </symbol>
        <symbol id="zui-file-word" viewBox="0 0 48 48">
            <title>zui-file-word</title>
            <path d="M40,13.9l-10-10v10H40z"/>
            <path d="M26,17.9v-14H12c-2.2,0-4,1.8-4,4v32c0,2.2,1.8,4,4,4h24c2.2,0,4-1.8,4-4v-22L26,17.9z M29.1,37.9h-3.3l-2.5-10.5l-2.5,10.5
	h-3.3L14,22.3h3.2l2.1,11.1L22,22.3h2.7l2.6,11.1l2-11.1h3.2L29.1,37.9z"/>
        </symbol>
        <symbol id="zui-file-zip" viewBox="0 0 48 48">
            <title>zui-file-zip</title>
            <path d="M36,4H24v4h4v4h-4v4h4v4h-4v4h4v16h-8V28h4v-4h-4v-4h4v-4h-4v-4h4V8h-4V4h-8C9.8,4,8,5.8,8,8v32c0,2.2,1.8,4,4,4h24
	c2.2,0,4-1.8,4-4V8C40,5.8,38.2,4,36,4z"/>
            <path d="M22.4,34.4h3v3h-3V34.4z"/>
        </symbol>



    <!-- Miscellaneous -->

        <symbol id="zui-add" viewBox="0 0 48 48">
            <title>zui-add</title>
            <path d="M10,34V14c-2.2,0-4,1.8-4,4v20c0,2.2,1.8,4,4,4h20c2.2,0,4-1.8,4-4H14C11.8,38,10,36.2,10,34z"/>
            <path d="M38,6H18c-2.2,0-4,1.8-4,4v20c0,2.2,1.8,4,4,4h20c2.2,0,4-1.8,4-4V10C42,7.8,40.2,6,38,6z M34,22h-4v4h-4v-4h-4v-4h4v-4h4v4
	h4V22z"/>
        </symbol>
        <symbol id="zui-building" viewBox="0 0 48 48">
            <title>zui-building</title>
            <path d="M8,4h32v4H8V4z"/>
            <path d="M10,6v34c0,2.2,1.8,4,4,4h2V34h6v10h12c2.2,0,4-1.8,4-4V6H10z M32,40h-6v-6h6V40z M32,30h-6v-6h6V30z M22,30h-6v-6h6V30z
	 M22,20h-6v-6h6V20z M32,20h-6v-6h6V20z"/>
        </symbol>
        <symbol id="zui-calendar" viewBox="0 0 48 48">
            <title>zui-calendar</title>
            <path d="M38,8.5h-2v2.3c0,1.3-0.7,2.5-1.8,3.1c-1.8,1.2-4.3,0.7-5.5-1.1c-0.4-0.7-0.7-1.5-0.7-2.3v-2h-8v2.3c0,1.3-0.7,2.5-1.8,3.1
	c-1.8,1.2-4.3,0.7-5.5-1.1c-0.4-0.7-0.7-1.5-0.7-2.3v-2H9.3C7.5,8.5,6,10,6,11.8v27.4c0,1.8,1.5,3.3,3.3,3.3h29.4
	c1.8,0,3.3-1.5,3.3-3.3V12.5C42,10.3,40.2,8.5,38,8.5 M10,38.5v-20h28v20 M16,12.5c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2s2,0.9,2,2v4
	C18,11.6,17.1,12.5,16,12.5 M32,12.5c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2s2,0.9,2,2v4C34,11.6,33.1,12.5,32,12.5 M18,26.5h-4v-4h4
	V26.5z M26,26.5h-4v-4h4V26.5z M34,26.5h-4v-4h4V26.5z M18,34.5h-4v-4h4V34.5z M26,34.5h-4v-4h4V34.5z M34,34.5h-4v-4h4V34.5z"/>
        </symbol>
        <symbol id="zui-calendar-check" viewBox="0 0 48 48">
            <title>zui-calendar-check</title>
            <path d="M38,8.5h-2v2.3c0,1.3-0.7,2.5-1.8,3.1c-1.8,1.2-4.3,0.7-5.5-1.1c-0.4-0.7-0.7-1.5-0.7-2.3v-2h-8v2.3c0,1.3-0.7,2.5-1.8,3.1
	c-1.8,1.2-4.3,0.7-5.5-1.1c-0.4-0.7-0.7-1.5-0.7-2.3v-2H9.3C7.5,8.5,6,10,6,11.8v27.4c0,1.8,1.5,3.3,3.3,3.3h29.4
	c1.8,0,3.3-1.5,3.3-3.3V12.5C42,10.3,40.2,8.5,38,8.5 M10,38.5v-20h28v20 M16,12.5c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2s2,0.9,2,2v4
	C18,11.6,17.1,12.5,16,12.5 M32,12.5c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2s2,0.9,2,2v4C34,11.6,33.1,12.5,32,12.5"/>
            <path d="M33,23.2l-9.2,9.2l-2.1,2.1L16,28.8l2.1-2.1l3.5,3.5l9.2-9.2L33,23.2z"/>
        </symbol>
        <symbol id="zui-carrier-shield" viewBox="0 0 48 48">
            <title>zui-carrier-shield</title>
            <path d="M19,33.5c0-8.3,6.7-15,15-15c1.4,0,2.7,0.2,4,0.6V7.5c-6,0-16-4-16-4c-5,2.4-10.5,3.8-16,4v22c0,6,16,14,16,14l0.6-0.3
	C20.3,40.5,19,37.1,19,33.5z"/>
            <path d="M34,21.5c-6.6,0-12,5.4-12,12s5.4,12,12,12s12-5.4,12-12S40.6,21.5,34,21.5z M32.4,41.7l-6.5-6.5l2.8-2.8l3.5,3.4l6.9-8.3
	l3.1,2.6L32.4,41.7z"/>
        </symbol>
        <symbol id="zui-carrier-umbrella" viewBox="0 0 48 48">
            <title>zui-carrier-umbrella</title>
            <path d="M44,22.1c-3.9-2.9-9.4-2.5-12.9,0.9c-1.4-1.4-3.2-2.3-5.1-2.7v17.8c0.3,3-2,5.7-5,6s-5.7-2-6-5c0-0.3,0-0.6,0-0.9v-1.5h3
	v1.5c0,0.5,0.2,3,2.5,3s2.5-2.5,2.5-3v-18c-2.3,0.2-4.4,1.2-6,2.8c-3.5-3.4-9-3.7-12.9-0.8c0.8-11,10.3-19.3,21.4-18.5
	C35.4,4.3,43.3,12.2,44,22.1z"/>
        </symbol>
        <symbol id="zui-chart-bar" viewBox="0 0 48 48">
            <title>zui-chart-bar</title>
            <path d="M8,40h32v4H8V40z M8,24h8v12H8V24z M20,14h8v22h-8V14z M32,4h8v32h-8V4z"/>
        </symbol>
        <symbol id="zui-chart-line" viewBox="0 0 48 48">
            <title>zui-chart-line</title>
            <path d="M42,38v4H6V6h4v32H42z"/>
            <path d="M40.9,16.2l-8.5,8.5c-0.8,0.7-2,0.7-2.7,0l-4.3-4.3l-7.1,7.1c-0.8,0.8-2,0.8-2.8,0c-0.8-0.8-0.8-2,0-2.8c0,0,0,0,0,0
	l8.2-8.2c1-1,2.5-1,3.5,0c0,0,0,0,0,0l4,4l6.9-7.1c0.8-0.8,2-0.8,2.8,0c0,0,0,0,0,0C41.6,14.2,41.6,15.4,40.9,16.2z"/>
        </symbol>
        <symbol id="zui-chart-pie" viewBox="0 0 48 48">
            <title>zui-chart-pie</title>
            <path d="M22,22V4.1c-9.5,1-17,8.5-17.9,18L22,22z M22,26H4.1c0.9,9.5,8.5,17.1,18,18L22,26z M26,4.1V44c11-1.1,19-10.9,17.9-21.9
	c-1-9.5-8.4-17-17.9-17.9V4.1z"/>
        </symbol>
        <symbol id="zui-dislike" viewBox="0 0 48 48">
            <title>zui-dislike</title>
            <path d="M42.2,30h-6V10h6V30z"/>
            <path d="M5.7,24.9l3.6-12c0.5-1.7,2.1-2.9,3.8-2.9h15c2.2,0,4,1.8,4,4v12c0,0.1,0,0.3,0,0.4c0.1,0.9-0.1,1.9-0.7,2.7L22.2,42
	L20,39.9c-1.1-1.1-1.5-2.9-0.9-4.3l2.3-5.5h-12c-2.2,0-4-1.9-3.9-4.1C5.5,25.6,5.6,25.2,5.7,24.9z"/>
        </symbol>
        <symbol id="zui-help-user" viewBox="0 0 48 48">
            <title>zui-help-user</title>
            <circle cx="17" cy="12.5" r="7"/>
            <path d="M31,17.5c-7.2,0-13,5.8-13,13s5.8,13,13,13s13-5.8,13-13S38.2,17.5,31,17.5z M34.5,30.1c-0.6,0.6-1,0.9-1.4,1.3
	c-0.8,0.7-0.8,0.7-0.8,1.7h-2.6c-0.1-1.5,0.5-2.9,1.8-3.7c0.4-0.3,0.8-0.7,1.2-1.1c0.7-0.8,0.8-1.9,0.4-2.9c-0.3-0.8-1.1-1.4-2-1.4
	c-2.4,0-2.6,2.5-2.6,2.8l-2.6-0.1c0.1-2.8,2.3-5.1,5.1-5.2c2,0,3.8,1.1,4.5,3C36.3,26.4,35.9,28.6,34.5,30.1z M31,39
	c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6C32.6,38.2,31.9,39,31,39z"/>
            <path d="M14,30.5c0-2.4,0.5-4.8,1.5-7c-4.1,0.3-8,1.6-11.5,3.8v6.2h10.3C14.1,32.5,14,31.5,14,30.5z"/>
        </symbol>
        <symbol id="zui-lightning-bolt" viewBox="0 0 48 48">
            <title>zui-lightning-bolt</title>
            <path d="M19.5,6h16l-8,14h8l-18,22l2-16h-6L19.5,6z"/>
        </symbol>
        <symbol id="zui-like" viewBox="0 0 48 48">
            <title>zui-like</title>
            <path d="M5.8,18h6v20h-6V18z M42.3,23.1l-3.6,12c-0.5,1.7-2.1,2.9-3.8,2.9h-15c-2.2,0-4-1.8-4-4V22c0-0.1,0-0.3,0-0.4
	c-0.1-0.9,0.1-1.9,0.7-2.7L25.8,6L28,8.1c1.1,1.1,1.5,2.9,0.9,4.3L26.5,18h12c2.2,0,4,1.9,3.9,4.1C42.5,22.4,42.4,22.8,42.3,23.1z" />
        </symbol>
        <symbol id="zui-location" viewBox="0 0 48 48">
            <title>zui-location</title>
            <path d="M24,4c-7.7,0-14,6.3-14,14c0,10,12,26,14,26s14-16,14-26C38,10.3,31.7,4,24,4z M24,24c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6
	S27.3,24,24,24z"/>
        </symbol>
        <symbol id="zui-medicine" viewBox="0 0 48 48">
            <title>zui-medicine</title>
            <path d="M18,5h12v4H18V5z M12,37c0,2.2,1.8,4,4,4h16c2.2,0,4-1.8,4-4v-4H12V37z M32,9H16c-2.2,0-4,1.8-4,4v4h24v-4
	C36,10.8,34.2,9,32,9z M29.1,23.5v3h-3.5V30h-3v-3.5h-3.5v-3h3.5V20h3v3.5H29.1z"/>
        </symbol>
        <symbol id="zui-network" viewBox="0 0 48 48">
            <title>zui-network</title>
            <path d="M18,20c-6.6,0-12,5.4-12,12s5.4,12,12,12s12-5.4,12-12S24.6,20,18,20z M18,24c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4
	S15.8,24,18,24z M18,41.2c-2.2,0-4.4-0.8-6-2.4c1.4-1.9,3.6-3,6-2.9c2.4-0.1,4.6,1,6,2.9C22.4,40.4,20.2,41.3,18,41.2z"/>
            <path d="M13,11h4v12h-4V11z"/>
            <path d="M15,7c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2s-2-0.9-2-2C13,7.9,13.9,7,15,7 M15,4c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5
	S17.8,4,15,4z"/>
            <path d="M34.2,11l2.8,2.8L24.4,26.4l-2.8-2.8L34.2,11z"/>
            <path d="M37,9c0.5,0,1,0.2,1.4,0.6c0.8,0.8,0.8,2,0,2.8c0,0,0,0,0,0c-0.8,0.8-2,0.8-2.8,0c0,0,0,0,0,0c-0.8-0.8-0.8-2,0-2.8
	c0,0,0,0,0,0C36,9.2,36.5,9,37,9 M37,6c-2.8,0-5,2.2-5,5c0,2.8,2.2,5,5,5c2.8,0,5-2.2,5-5c0-1.3-0.5-2.6-1.5-3.5
	C39.6,6.5,38.3,6,37,6z"/>
            <path d="M34,30v4H22v-4H34z"/>
            <path d="M36,30c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S34.9,30,36,30 M36,27c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5S38.8,27,36,27z" />
        </symbol>
        <symbol id="zui-pill" viewBox="0 0 48 48">
            <title>zui-pill</title>
            <path d="M38.1,9.9C34.2,6,27.9,6,24,9.9L9.8,24c-1.5,1.5-2.5,3.5-2.8,5.6c-0.7,5.5,3.1,10.5,8.6,11.3c0.9,0.1,1.8,0.1,2.7,0
	c2.1-0.3,4.1-1.2,5.7-2.7L38.1,24C42,20.1,42,13.8,38.1,9.9z M26.8,12.7c2.3-2.3,6.2-2.3,8.5,0s2.3,6.2,0,8.5l-7.1,7.1l-8.5-8.5
	L26.8,12.7z"/>
        </symbol>
        <symbol id="zui-syringe" viewBox="0 0 48 48">
            <title>zui-syringe</title>
            <path d="M35.1,15.8l2.8-2.8l2.8,2.8l2.8-2.8l-8.5-8.5l-2.8,2.8l2.8,2.8l-2.8,2.8L28,8.7l-17,17l1.4,1.4l-1.7,1.8l2.9,2.8l-6.8,6.8
	l-1.5,4.2l4.2-1.4l6.8-6.8l2.8,2.8l1.8-1.7l1.4,1.4l17-17L35.1,15.8z M33.7,20L22.3,31.3l-2.8-2.9l11.3-11.3L33.7,20z"/>
        </symbol>
        <symbol id="zui-user-check" viewBox="0 0 48 48">
            <title>zui-user-check</title>
            <path d="M32,20c-6.6,0-12,5.4-12,12s5.4,12,12,12s12-5.4,12-12S38.6,20,32,20z M30.4,40.2l-6.5-6.5l2.8-2.8l3.5,3.4L37,26l3.1,2.6
	L30.4,40.2z"/>
            <path d="M17,32H8v-5.6c3.6-2.2,7.8-3.4,12-3.4c2.8-3.8,7.3-6,12-6c1.4,0,2.7,0.2,4,0.6V8c0-2.2-1.8-4-4-4H8C5.8,4,4,5.8,4,8v24
	c0,2.2,1.8,4,4,4h9.6C17.2,34.7,17,33.4,17,32z M20,8c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S16.7,8,20,8z"/>
        </symbol>



    <!-- Navigation -->

        <symbol id="zui-account-management" viewBox="0 0 48 48">
            <title>zui-account-management</title>
            <circle cx="15" cy="13" r="5"/>
            <path d="M14,32.5c0-0.7,0.1-1.5,0.3-2.2c1.4-3.4,4.3-6,7.9-7C19.9,22.4,17.5,22,15,22c-5.5,0-10.1,2.1-10.9,4.8
	C4,27.1,4,27.3,4,27.6V34h10V32.5z M44,32.5V40H18v-7.5c0-0.3,0-0.6,0.1-0.9C19,28.4,24.5,26,31,26s12,2.5,12.9,5.6
	C44,31.9,44,32.2,44,32.5z"/>
            <circle cx="31" cy="15" r="7"/>
        </symbol>
        <symbol id="zui-accounts" viewBox="0 0 48 48">
            <title>zui-accounts</title>
            <path d="M40,12v24c0,2.2-1.8,4-4,4H12c0,2.2,1.8,4,4,4h24c2.2,0,4-1.8,4-4V16C44,13.8,42.2,12,40,12z"/>
            <path d="M32,4H8C5.8,4,4,5.8,4,8v24c0,2.2,1.8,4,4,4h24c2.2,0,4-1.8,4-4V8C36,5.8,34.2,4,32,4z M20,8c3.3,0,6,2.7,6,6s-2.7,6-6,6
	s-6-2.7-6-6S16.7,8,20,8z M32,32H8v-5.6c7.4-4.5,16.6-4.5,24,0V32z"/>
        </symbol>
        <symbol id="zui-admin" viewBox="0 0 48 48">
            <title>zui-admin</title>
            <path d="M17,34v-7h3l-2-2l0.9-0.9C13.6,24.3,8.5,25.8,4,28.5V36h13V34z M23.8,19l1.2-1.2l0.2,0.2c3.4-2.9,3.8-7.9,0.9-11.3
	C23.1,3.4,18.1,3,14.7,5.9s-3.8,7.9-0.9,11.3C15.4,19,17.6,20,20,20C21.3,20,22.6,19.7,23.8,19z"/>
            <path d="M44,34v-4h-2.2c-0.3-1.3-0.8-2.5-1.5-3.5l1.6-1.6l-2.8-2.8l-1.6,1.6c-1.1-0.7-2.3-1.2-3.5-1.5V20h-4v2.2
	c-1.3,0.3-2.5,0.8-3.5,1.5l-1.6-1.6l-2.8,2.8l1.6,1.6c-0.7,1.1-1.2,2.3-1.5,3.5H20v4h2.2c0.3,1.3,0.8,2.5,1.5,3.5l-1.6,1.6l2.8,2.9
	l1.6-1.6c1.1,0.7,2.3,1.1,3.5,1.4V44h4v-2.2c1.3-0.3,2.5-0.8,3.5-1.5l1.6,1.6l2.9-2.8l-1.6-1.6c0.7-1.1,1.1-2.3,1.4-3.5H44z M32,36
	c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S34.2,36,32,36z"/>
            <path d="M44,34v-4h-2.2c-0.3-1.3-0.8-2.5-1.5-3.5l1.6-1.6l-2.8-2.8l-1.6,1.6c-1.1-0.7-2.3-1.2-3.5-1.5V20h-4v2.2
	c-1.3,0.3-2.5,0.8-3.5,1.5l-1.6-1.6l-2.8,2.8l1.6,1.6c-0.7,1.1-1.2,2.3-1.5,3.5H20v4h2.2c0.3,1.3,0.8,2.5,1.5,3.5l-1.6,1.6l2.8,2.9
	l1.6-1.6c1.1,0.7,2.3,1.1,3.5,1.4V44h4v-2.2c1.3-0.3,2.5-0.8,3.5-1.5l1.6,1.6l2.9-2.8l-1.6-1.6c0.7-1.1,1.1-2.3,1.4-3.5H44z M32,36
	c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S34.2,36,32,36z"/>
        </symbol>
        <symbol id="zui-apps" viewBox="0 0 48 48">
            <title>zui-apps</title>
            <path d="M16 9v6c0 .6-.4 1-1 1H9c-.6 0-1-.4-1-1V9c0-.6.4-1 1-1h6c.6 0 1 .4 1 1zm11-1h-6c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V9c0-.6-.4-1-1-1zM15 32H9c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h6c.6 0 1-.4 1-1v-6c0-.6-.4-1-1-1zM39 8h-6c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V9c0-.6-.4-1-1-1zM15 20H9c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h6c.6 0 1-.4 1-1v-6c0-.6-.4-1-1-1zm12 0h-6c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h6c.6 0 1-.4 1-1v-6c0-.6-.4-1-1-1zm0 12h-6c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h6c.6 0 1-.4 1-1v-6c0-.6-.4-1-1-1zm12-12h-6c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h6c.6 0 1-.4 1-1v-6c0-.6-.4-1-1-1zm0 12h-6c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h6c.6 0 1-.4 1-1v-6c0-.6-.4-1-1-1z"/>
        </symbol>
        <symbol id="zui-books" viewBox="0 0 48 48">
            <title>zui-books</title>
            <path d="M3.5,8.9v32h8v-32H3.5z M8.8,22.9h-3v-10h3V22.9z M25.5,4.9v36h8v-36H25.5z M30.9,19.1h-3v-10h3V19.1z M14.3,14.9v26h8v-26
	H14.3z M19,37.1c-0.8,0.3-1.7-0.1-1.9-0.9c-0.3-0.8,0.1-1.7,0.9-1.9c0.8-0.3,1.6,0.1,1.9,0.9C20.2,35.9,19.9,36.8,19,37.1
	C19.1,37.1,19,37.1,19,37.1z M33.5,15.7l4.2,25.7l7.8-1.3l-4.2-25.7L33.5,15.7z"/>
        </symbol>
        <symbol id="zui-carrier-info" viewBox="0 0 48 48">
            <title>zui-carrier-info</title>
            <path d="M24,4C19,6.4,13.5,7.8,8,8v22c0,6,16,14,16,14s16-8,16-14V8C34,8,24,4,24,4z M28,14c0,2.2-1.8,4-4,4s-4-1.8-4-4s1.8-4,4-4
	S28,11.8,28,14z M28,36h-8V22h8V36z"/>
        </symbol>
        <symbol id="zui-carrier" viewBox="0 0 48 48">
            <title>zui-carrier</title>
            <path d="M24,4C19,6.4,13.5,7.8,8,8v22c0,6,16,14,16,14s16-8,16-14V8C34,8,24,4,24,4z"/>
        </symbol>
        <symbol id="zui-checklist" viewBox="0 0 48 48">
            <title>zui-checklist</title>
            <path d="M17.6,38.5h-6.1c-0.5,0-1-0.4-1-1c0,0,0,0,0,0v-24c0-0.6,0.4-1,1-1h1v1.1c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1v-1.1h1
	c0.6,0,1,0.4,1,1v3.2c0.7-0.1,1.3-0.2,2-0.2c0.7,0,1.3,0.1,2,0.1v-5.2c0-1.6-1.4-3-3-3h-3.2c-0.4-1.2-1.5-2-2.8-2h-0.1
	c-0.5-2.7-3.1-4.5-5.8-3.9c-2,0.4-3.6,1.9-3.9,3.9c-1.3,0-2.4,0.8-2.8,2H9.5c-1.7,0-3,1.3-3,3v28c0,1.7,1.3,3,3,3l0,0H20
	C19,41.3,18.2,39.9,17.6,38.5z M20.5,5.5c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2s-2-0.9-2-2C18.5,6.4,19.4,5.5,20.5,5.5z"/>
            <path d="M32.5,20.5c-6.6,0-12,5.4-12,12s5.4,12,12,12s12-5.4,12-12S39.1,20.5,32.5,20.5z M30.9,40.7l-6.5-6.5l2.8-2.8l3.5,3.4
	l6.9-8.3l3.1,2.6L30.9,40.7z"/>
        </symbol>
        <symbol id="zui-compass" viewBox="0 0 48 48">
            <title>zui-compass</title>
            <path d="M25.4,25.4c0.8-0.8,0.8-2.1,0-2.8s-2.1-0.8-2.8,0c-0.8,0.8-0.8,2,0,2.8C23.4,26.2,24.6,26.2,25.4,25.4
	C25.4,25.4,25.4,25.4,25.4,25.4z"/>
            <path d="M24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20S35,4,24,4z M28.2,28.2l-15.6,7.1l7.1-15.6l15.6-7.1L28.2,28.2z"/>
        </symbol>
        <symbol id="zui-community" viewBox="0 0 48 48">
            <title>zui-community</title>
            <path d="M24,8c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S22.9,8,24,8 M24,4c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S27.3,4,24,4z M38,22
	c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S36.9,22,38,22 M38,18c-3.3,0-6,2.7-6,6s2.7,6,6,6c3.3,0,6-2.7,6-6S41.3,18,38,18z M24,36
	c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S22.9,36,24,36 M24,32c-3.3,0-6,2.7-6,6c0,3.3,2.7,6,6,6s6-2.7,6-6C30,34.7,27.3,32,24,32z" />
            <path d="M35.1,18.8C36,18.3,37,18,38,18c0.2,0,0.4,0,0.5,0c-1.6-3.9-4.7-7-8.5-8.6c0,0.2,0,0.4,0,0.6c0,1-0.3,2-0.8,2.9
	C31.8,14.1,33.9,16.2,35.1,18.8z M38,30c-1,0-2-0.3-2.9-0.8c-1.2,2.6-3.3,4.7-5.9,5.9C29.7,36,30,37,30,38c0,0.2,0,0.4,0,0.5
	c3.9-1.6,7-4.7,8.6-8.5C38.4,30,38.2,30,38,30z M10,18c1,0,2,0.3,2.9,0.8c1.2-2.6,3.3-4.7,5.9-5.9C18.3,12,18,11,18,10
	c0-0.2,0-0.4,0-0.6c-3.9,1.6-6.9,4.7-8.5,8.6C9.6,18,9.8,18,10,18z M12.9,29.2C12,29.7,11,30,10,30c-0.2,0-0.4,0-0.5,0
	c1.6,3.9,4.7,7,8.5,8.6c0-0.2,0-0.4,0-0.6c0-1,0.3-2,0.8-2.9C16.2,33.9,14.1,31.8,12.9,29.2z"/>
            <path d="M10,22c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S8.9,22,10,22 M10,18c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S13.3,18,10,18z"/>
        </symbol>
        <symbol id="zui-folder" viewBox="0 0 48 48">
            <title>zui-folder</title>
            <path d="M44,16v20c0,2.2-1.8,4-4,4H8c-2.2,0-4-1.8-4-4V11.2C4,9.4,5.4,8,7.2,8H20l4,4h16C42.2,12,44,13.8,44,16z"/>
        </symbol>
        <symbol id="zui-gear" viewBox="0 0 48 48">
            <title>zui-gear</title>
            <path d="M39.5,21.9l4.5-2.6L38,8.9l-4.2,2.5l-4-2.2V4H18v4.9l-3.8,2.5L9.8,8.8l-6,10.4l4.5,2.6l-0.2,4.5l-4.2,2.5l6,10.4l4.4-2.5
	L18,39v5h11.9v-5.1l3.9-2.2l4.2,2.5l6-10.4l-4.2-2.5L39.5,21.9z M24,30c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S27.4,30,24,30z"/>
        </symbol>
        <symbol id="zui-graduation-cap" viewBox="0 0 48 48">
            <title>zui-graduation-cap</title>
            <path d="M3.5,18l20,12l18-10v14h4V18l-22-12L3.5,18z"/>
            <path d="M9.5,26v8l14,8l14-8v-8l-14,8L9.5,26z"/>
        </symbol>
        <symbol id="zui-grip" viewBox="0 0 48 48">
            <title>zui-grip</title>
            <circle cx="19" cy="9" r="3"/>
            <circle cx="29" cy="9" r="3"/>
            <circle cx="19" cy="19" r="3"/>
            <circle cx="29" cy="19" r="3"/>
            <circle cx="19" cy="29" r="3"/>
            <circle cx="29" cy="29" r="3"/>
            <circle cx="19" cy="39" r="3"/>
            <circle cx="29" cy="39" r="3"/>
        </symbol>
        <symbol id="zui-heartbeat" viewBox="0 0 48 48">
            <title>zui-heartbeat</title>
            <path d="M6.8,21.9c0,0,0,0.1,0,0.1c0,0.2,0.2,0.3,0.2,0.5h8l5-10L26,26l3.9-9.7l3.1,6.2h8c0-0.2,0.2-0.3,0.2-0.5c0,0,0-0.1,0-0.1
	c0.4-0.9,0.7-1.9,0.8-2.9c0-0.3,0-0.6,0-0.9c0-5.5-4.5-10-10-10c-3.1,0-6.1,1.5-8,4c-3.3-4.4-9.6-5.3-14-2c-2.5,1.9-4,4.9-4,8
	c0,0.3,0,0.6,0,0.9C6.1,19.9,6.4,20.9,6.8,21.9z"/>
            <path d="M31.1,25.5l-0.9-1.8L26,34l-6-14.4l-3,6H8.6C13.6,33.4,24,40,24,40s10.4-6.6,15.4-14.5H31.1z"/>
        </symbol>
        <symbol id="zui-home" viewBox="0 0 48 48">
            <title>zui-home</title>
            <path d="M46,25.5h-4v20H28v-16h-8v16H6v-20H2l22-22L46,25.5z"/>
        </symbol>
        <symbol id="zui-lightbulb" viewBox="0 0 48 48">
            <title>zui-lightbulb</title>
            <path d="M38,15.6V16c-0.1,5-3.5,9.6-6.9,13.3C30.4,30,30,31,30,32v4H18v-4c0-0.9-0.4-1.8-1-2.5c-3.5-3.8-7-8.7-7-14
	C10,8,16.1,2,23.6,2c0.1,0,0.2,0,0.3,0c7.6-0.2,14,5.9,14.1,13.5C38,15.5,38,15.6,38,15.6z M20,42h8c0,2.2-1.8,4-4,4S20,44.2,20,42z
	"/>
        </symbol>
        <symbol id="zui-lists" viewBox="0 0 48 48">
            <title>zui-lists</title>
            <path d="M4,8h8v8H4V8z M4,20h8v8H4V20z M4,32h8v8H4V32z M16,8h28v8H16V8z M16,20h28v8H16V20z M16,32h28v8H16V32z"/>
        </symbol>
        <symbol id="zui-menu" viewBox="0 0 48 48">
            <title>zui-menu</title>
            <path d="M8,12h32v4H8V12z M8,22h32v4H8V22z M8,32h32v4H8V32z"/>
        </symbol>
        <symbol id="zui-monitor" viewBox="0 0 48 48">
            <title>zui-monitor</title>
            <path d="M39.9,7.1h-32c-2.2,0-4,1.8-4,4v22c0,2.2,1.8,4,4,4h10v3.8h-1c-0.5,0-1,0.4-1,1c0,0,0,0,0,0c0,0.6,0.4,1,1,1h14
	c0.6,0,1-0.4,1-1c0-0.5-0.4-1-1-1c0,0,0,0,0,0h-1v-3.8h10c2.2,0,4-1.8,4-4v0v-22C43.9,8.9,42.1,7.1,39.9,7.1z M39.9,33.1h-32v-22h32
	V33.1z"/>
            <circle cx="23.9" cy="17.2" r="3"/>
            <path d="M29.9,29.1h-12v-3.7c3.4-3,8.6-3,12,0V29.1z"/>
        </symbol>
        <symbol id="zui-more" viewBox="0 0 48 48">
            <title>zui-more</title>
            <circle cx="24" cy="10" r="4"/>
            <circle cx="24" cy="24" r="4"/>
            <circle cx="24" cy="38" r="4"/>
        </symbol>
        <symbol id="zui-notebook" viewBox="0 0 48 48">
            <title>zui-notebook</title>
            <path d="M36.5,4h-24c-2.2,0-4,1.8-4,4v2h-2v4h2v4h-2v4h2v4h-2v4h2v4h-2v4h2v2c0,2.2,1.8,4,4,4h24c2.2,0,4-1.8,4-4V8
	C40.5,5.8,38.7,4,36.5,4z M14.5,18h18v4h-18V18z M30.5,38h-16v-4h16V38z M36.5,30h-22v-4h22V30z M36.5,14h-22v-4h22V14z"/>
        </symbol>
        <symbol id="zui-paper" viewBox="0 0 48 48">
            <title>zui-paper</title>
            <path d="M36,4H12C9.8,4,8,5.8,8,8v32c0,2.2,1.8,4,4,4h24c2.2,0,4-1.8,4-4V8C40,5.8,38.2,4,36,4z M36,34H12v-4h24V34z M36,26H12v-4
	h24V26z M36,18H12v-4h24V18z"/>
        </symbol>
        <symbol id="zui-papers" viewBox="0 0 48 48">
            <title>zui-papers</title>
            <path d="M36,12v24c0,2.2-1.8,4-4,4H16c0,2.2,1.8,4,4,4h16c2.2,0,4-1.8,4-4V16C40,13.8,38.2,12,36,12z"/>
            <path d="M28,4H12C9.8,4,8,5.8,8,8v24c0,2.2,1.8,4,4,4h16c2.2,0,4-1.8,4-4V8C32,5.8,30.2,4,28,4z M28,13H12v-3h16V13z M28,19H12v-3
	h16V19z M22,25H12v-3h10V25z"/>
        </symbol>
        <symbol id="zui-portal" viewBox="0 0 48 48">
            <title>zui-portal</title>
            <path d="M24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20S35,4,24,4z M36,34.6c-4.1-6.6-12.7-8.6-19.3-4.5c-1.8,1.1-3.4,2.7-4.5,4.5
	C9.5,31.7,8,27.9,8,24c0-8.8,7.2-16,16-16s16,7.2,16,16C40,27.9,38.6,31.7,36,34.6z"/>
            <circle cx="24" cy="18" r="6"/>
        </symbol>
        <symbol id="zui-portal-admin" viewBox="0 0 48 48">
            <title>zui-portal-admin</title>
            <path d="M24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20S35,4,24,4z M28,39.5v-8.3c5.1-2.2,7.4-8.1,5.2-13.2c-1-2.3-2.9-4.2-5.2-5.2V22
	l-4,2l-4-2v-9.2c-5.1,2.2-7.4,8.1-5.2,13.2c1,2.3,2.9,4.2,5.2,5.2v8.3C11.4,37.3,6.3,28.6,8.5,20C10.7,11.5,19.4,6.3,28,8.5
	S41.7,19.5,39.5,28C38,33.6,33.6,38,28,39.5z"/>
        </symbol>
        <symbol id="zui-presentations" viewBox="0 0 48 48">
            <title>zui-presentations</title>
            <path d="M8,38c-1.1,0-2-0.9-2-2V12c0-1.1,0.9-2,2-2h32c1.1,0,2,0.9,2,2H28v12c0-5.5-4.5-10-10-10h-2v2c-5.5,0-10,4.5-10,10
	s4.5,10,10,10s10-4.5,10-10h2v10h14c0,1.1-0.9,2-2,2H8z"/>
            <path d="M26,12v3.1c-2.2-2-5-3.1-8-3.1H26 M14,12v2.2c-2.2,0.4-4.3,1.4-6,2.9V12H14 M26,32.6V36h-3.4C24,35.1,25.1,34,26,32.6
	 M8,34.9c0.4,0.4,0.9,0.7,1.4,1.1H8V34.9 M40,8H8c-2.2,0-4,1.8-4,4v24c0,2.2,1.8,4,4,4h32c2.2,0,4-1.8,4-4V12C44,9.8,42.2,8,40,8z
	 M30,18v-4h10v4H30z M18,24v-8c4.4,0,8,3.6,8,8H18z M16,34c-4.4,0-8-3.6-8-8s3.6-8,8-8v8h8C24,30.4,20.4,34,16,34z M30,26v-4h10v4
	H30z M30,34v-4h10v4H30z"/>
        </symbol>
        <symbol id="zui-proposals" viewBox="0 0 48 48">
            <title>zui-proposals</title>
            <path d="M40,14L30,4v10H40z"/>
            <path d="M26,18V4H12C9.8,4,8,5.8,8,8v32c0,2.2,1.8,4,4,4h24c2.2,0,4-1.8,4-4V18H26z M25.6,37.8V40h-3v-2.2c-2-0.2-3.5-1.8-3.7-3.8
	h2.2c0.1,1.2,0.9,2.1,3,2.1s2.7-1.1,2.7-1.8s-0.5-1.8-3-2.4s-4.7-1.8-4.7-4.1c0.2-1.9,1.6-3.4,3.5-3.6V22h3v2.2
	c1.8,0.4,3.2,2,3.2,3.8h-2.2c0-1.2-0.7-2.1-2.5-2.1s-2.7,0.8-2.7,1.9s0.7,1.5,3,2.1s4.7,1.6,4.7,4.4C29.1,36.3,27.5,37.5,25.6,37.8z
	"/>
        </symbol>
        <symbol id="zui-reload-circle" viewBox="0 0 48 48">
            <title>zui-reload-circle</title>
            <path d="M24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20S35,4,24,4z M24,36c-6.6,0-12-5.4-12-12s5.4-12,12-12c2.9,0,5.7,1.1,7.9,3l2.9-3
	v8.5h-8.5l2.7-2.7c-3.4-2.8-8.4-2.4-11.3,1c-2.8,3.4-2.4,8.4,1,11.3c3.4,2.8,8.4,2.4,11.3-1c1.2-1.4,1.8-3.2,1.9-5.1h4
	C36,30.6,30.6,36,24,36z"/>
        </symbol>
        <symbol id="zui-rfps" viewBox="0 0 48 48">
            <title>zui-rfps</title>
            <path d="M40,14L30,4v10H40z"/>
            <path d="M26,18V4H12C9.8,4,8,5.8,8,8v32c0,2.2,1.8,4,4,4h24c2.2,0,4-1.8,4-4V18H26z M14,31.4V36h-2.5V24H15c1.3-0.1,2.5,0.2,3.6,0.9
	c0.8,0.6,1.3,1.7,1.2,2.7c0,0.7-0.2,1.3-0.6,1.9c-0.4,0.6-1,1-1.7,1.3c1.8,2.7,3,4.4,3.5,5.2h-2.8l-2.9-4.6L14,31.4z M14,29.4h0.8
	c0.6,0,1.2-0.1,1.8-0.4c0.4-0.3,0.6-0.8,0.6-1.3c0-0.5-0.2-1-0.6-1.2c-0.6-0.3-1.2-0.4-1.8-0.4H14V29.4z M24.3,36h-2.5V24h6.9v2
	h-4.4v3.1h4v2h-4V36z M38,27.7c0.1,1.1-0.4,2.2-1.2,3c-1,0.7-2.2,1.1-3.4,1h-1.1V36h-2.6V24h3.8c1.2-0.1,2.4,0.3,3.3,0.9
	C37.7,25.6,38.1,26.7,38,27.7z M32.3,29.6h0.8c0.6,0.1,1.2-0.1,1.7-0.5c0.4-0.3,0.6-0.8,0.6-1.3c0-0.5-0.1-1-0.5-1.3
	c-0.4-0.3-1-0.5-1.5-0.4h-1.2V29.6z"/>
        </symbol>
        <symbol id="zui-rocket" viewBox="0 0 48 48">
            <title>zui-rocket</title>
            <path d="M10.5,33.5l4,4l-6.2,2.2 M26.7,31l8.9-7.4l1-0.9c3.1-3.1,2.8-14.1,2.8-14.1s-11-0.3-14.1,2.8l-0.9,1L17,21.3H9.7L6.9,27
	l6.4,1.3c-0.2,0.5-0.4,1.1-0.7,1.5l5.7,5.7c0.5-0.3,1-0.5,1.5-0.7l1.3,6.4l5.7-2.8V31z M29,19c-1.1-1-1.1-2.8,0-3.8c0,0,0,0,0,0
	c1.1-1.1,2.8-1.1,3.9,0c1.1,1.1,1.1,2.8,0,3.9l0,0C31.8,20.1,30.1,20.1,29,19C29,19.1,29,19,29,19z"/>
        </symbol>
        <symbol id="zui-search-fill" viewBox="0 0 48 48">
            <title>zui-search-fill</title>
            <path d="M17.5,17.4c-2.4,2.4-2.4,6.4,0,8.8c2.4,2.4,6.4,2.4,8.8,0c2.4-2.4,2.4-6.4,0-8.8C23.8,14.9,19.9,14.9,17.5,17.4
	C17.5,17.4,17.5,17.4,17.5,17.4z"/>
            <path d="M24,2C11.8,2,2,11.8,2,24s9.8,22,22,22s22-9.8,22-22S36.2,2,24,2z M37.4,37.3c-0.8,0.8-2,0.8-2.8,0c0,0,0,0,0,0l-7.1-7.1
	L27.2,30c-4.5,3-10.6,1.9-13.6-2.6c-3-4.5-1.9-10.6,2.6-13.6s10.6-1.9,13.6,2.6c2.2,3.2,2.3,7.5,0.2,10.7l0.3,0.3l7.1,7.1
	C38.2,35.3,38.2,36.5,37.4,37.3C37.4,37.3,37.4,37.3,37.4,37.3z"/>
        </symbol>
        <symbol id="zui-selector" viewBox="0 0 48 48">
            <title>zui-selector</title>
            <path d="M16,39h18v6H16V39z M34,22.4L32,35H18l-8-12c0-1.4,1.1-2.5,2.5-2.5c0.4,0,0.8,0.1,1.1,0.3L14,21l4,4V9c0-1.1,0.9-2,2-2
	s2,0.9,2,2v8l8.7,1.4C32.6,18.8,34,20.4,34,22.4z"/>
            <path d="M4,1v28h6.4l-2-3H7V4h34v22h-4.5L36,29h8V1H4z"/>
        </symbol>
        <symbol id="zui-speech" viewBox="0 0 48 48">
            <title>zui-speech</title>
            <path d="M44,24c0,8.8-9,16-20,16c-3.7,0-7.4-0.8-10.7-2.5L6,40l2-6.3c-2.5-2.6-4-6.1-4-9.7c0-8.8,9-16,20-16S44,15.2,44,24z"/>
        </symbol>
        <symbol id="zui-toolbox" viewBox="0 0 48 48">
            <title>zui-toolbox</title>
            <path d="M40,13h-6V5H14v8H8c-2.2,0-4,1.8-4,4v2h40v-2C44,14.8,42.2,13,40,13z M18,13V9h12v4H18z M30,23c0,2.2-1.8,4-4,4h-4
	c-2.2,0-4-1.8-4-4H4v14c0,2.2,1.8,4,4,4h32c2.2,0,4-1.8,4-4V23H30z"/>
        </symbol>
        <symbol id="zui-zywave-sidebar" viewBox="0 0 48 48">
            <title>zui-zywave-sidebar</title>
            <path d="M40,12v24H8V12H40 M40,8H8c-2.2,0-4,1.8-4,4v24c0,2.2,1.8,4,4,4h32c2.2,0,4-1.8,4-4V12C44,9.8,42.2,8,40,8z"/>
            <path d="M30,15h7v18h-7V15z"/>
        </symbol>



    <!-- Speech -->
    
        <symbol id="zui-speech-phone" viewBox="0 0 48 48">
            <title>zui-speech-phone</title>
            <path d="M40,31c-2.4,0-4.8-0.4-7.1-1.1c-0.7-0.2-1.5,0-2,0.5l-4.4,4.4c-5.7-2.9-10.3-7.5-13.2-13.2l4.4-4.4c0.5-0.5,0.7-1.3,0.5-2
	C17.4,12.8,17,10.4,17,8c0-1.1-0.9-2-2-2H8C6.9,6,6,6.9,6,8c0,18.8,15.2,34,34,34c1.1,0,2-0.9,2-2v-7C42,31.9,41.1,31,40,31z"/>
        </symbol>
        <symbol id="zui-speech-chat" viewBox="0 0 48 48">
            <title>zui-speech-chat</title>
            <path d="M40,6H8c-2.2,0-4,1.8-4,4v22c0,2.2,1.8,4,4,4h14l8,6v-6h10c2.2,0,4-1.8,4-4V10C44,7.8,42.2,6,40,6z M30,26H10v-4h20V26z
	 M38,18H10v-4h28V18z"/>
        </symbol>
        <symbol id="zui-speech-feedback" viewBox="0 0 48 48">
            <title>zui-speech-feedback</title>
            <path d="M40,6H8c-2.2,0-4,1.8-4,4v22c0,2.2,1.8,4,4,4h14l8,6v-6h10c2.2,0,4-1.8,4-4V10C44,7.8,42.2,6,40,6z M27,22h-6V10h6V22z
	 M27,32h-6v-6h6V32z"/>
        </symbol>
        <symbol id="zui-speech-help" viewBox="0 0 48 48">
            <title>zui-speech-help</title>
            <path d="M40,4H8C5.8,4,4,5.8,4,8v26c0,2.2,1.8,4,4,4h14l8,6v-6h10c2.2,0,4-1.8,4-4V8C44,5.8,42.2,4,40,4z M29.4,21.4
	c-0.9,0.9-1.6,1.5-2.2,2c-1.3,1-1.3,1-1.3,2.6h-4c-0.3-2.3,0.8-4.5,2.7-5.7c0.5-0.4,1.1-0.9,1.9-1.7c1-1.3,1.3-3,0.6-4.5
	c-0.5-1.3-1.8-2.2-3.2-2.1c-3.7,0-4,3.9-4,4.3l-4-0.2c0-4.4,3.6-8,8-8.1c3-0.1,5.8,1.8,6.9,4.6C32.2,15.6,31.6,19,29.4,21.4z M24,35
	c-1.4,0-2.5-1.1-2.5-2.5S22.6,30,24,30s2.5,1.1,2.5,2.5S25.4,35,24,35z"/>
        </symbol>
        <symbol id="zui-speech-mail" viewBox="0 0 48 48">
            <title>zui-speech-mail</title>
            <path d="M24,21.7l20-10.9V8H4v2.8L24,21.7z"/>
            <path d="M24,26.3L4,15.4V40h40V15.4L24,26.3z"/>
        </symbol>
    </defs>
</svg>`;
document.head.appendChild($_iconsContainer);